import { useState } from "react";

const VentilationInfo = ({
  codingscreendata,
  typeOfPatient,
  handleMvhoursupdation,
  mvHours,
  setMvHours,
  nivHours,
  setNivHours,
  isLockedCoder,
}) => {
  const handleHoursKeyDown = (e) => {
    if (["-", "+", "e", "E"].includes(e.key)) {
      e.preventDefault();
      return;
    }
    handleMvhoursupdation(e);
  };

  // catches everything else: spinner clicks, paste, autofill
  const handleHoursChange = (setter) => (e) => {
    const val = e.target.value;

    if (val === "") {
      setter(val);
      return;
    }

    const num = Number(val);
    if (Number.isNaN(num)) return; // ignore garbage

    // clamp: never allow below 0
    setter(String(Math.max(0, num)));
  };

  return (
    <div>
      <div>
        {/* icu, mv, niv */}
        <div
          className="code-screen-hours-icu-mv"
          style={{
            marginBottom: `${typeOfPatient == "outPatient" ? ".8rem" : " "}`,
          }}
        >
          <span>
            ICU Hours:{" "}
            <span style={{ color: "#252C32", fontWeight: "normal" }}>
              {codingscreendata?.data?.meta?.icu_hours ?? "None"}
            </span>
          </span>

          <span>
            MV Hours:{" "}
            <span style={{ color: "#252C32", fontWeight: "normal" }}>
              {/* {codingscreendata?.data?.meta?.hours_of_mechanical_ventilation ??
                "None"} */}
              <input
                type="number"
                value={mvHours ?? ""}
                disabled={isLockedCoder}
                onKeyDown={handleHoursKeyDown}
                onChange={handleHoursChange(setMvHours)}
                placeholder="None"
                style={{
                  color: "#252C32",
                  fontWeight: "normal",
                  border: "1px solid #ccc",
                  padding: "0px 0px 0px 8px",
                  borderRadius: "4px",
                  width: "100px",
                }}
              />
            </span>
          </span>
            <span>
            NIV Hours:{" "}
            <span style={{ color: "#252C32", fontWeight: "normal" }}>
              {/* {codingscreendata?.data?.meta?.hours_of_mechanical_ventilation ??
                "None"} */}
              <input
                type="number"
                value={nivHours ?? ""}
                disabled={isLockedCoder}
                onKeyDown={handleHoursKeyDown}
                onChange={handleHoursChange(setNivHours)}
                placeholder="None"
                style={{
                  color: "#252C32",
                  fontWeight: "normal",
                  border: "1px solid #ccc",
                  padding: "0px 0px 0px 8px",
                  borderRadius: "4px",
                  width: "100px",
                }}
              />
            </span>
          </span>
          {/* <span>NIV Hours: 8</span> */}
        </div>
      </div>
    </div>
  );
};

export default VentilationInfo;
